import debounce from 'framework-ui-components/Components/Utils/debouncer';
import useEventListener from '../../../hooks/useEventListener';
import usePluginHandler from '../../../hooks/usePluginHandler';
import { isCalledByParent } from '../../../models/caller';
import { PluginMessageTypes } from '../../../models/constants';
import MessagesPlugin from '../../../models/messages';

const onFocus = debounce(() => {
  MessagesPlugin.postMessageToChilds(PluginMessageTypes.FOCUS);
  if (isCalledByParent()) {
    MessagesPlugin.postMessageToParent(PluginMessageTypes.FOCUS);
  }
}, 10);

const eventoFocus = debounce(() => {
  // lancio un evento di click (firmato da plugins) nel body
  const event = new MouseEvent('click', { bubbles: true });
  event.fromPluginsEvent = true;
  document.body.dispatchEvent(event);
}, 10);

const messageHandler = (message) => {
  if (message.type === PluginMessageTypes.FOCUS) {
    eventoFocus();
  }
};

/**
 * Reagisce al click sul IFrame.
 */
export default function useFocus() {
  usePluginHandler(messageHandler);
  useEventListener('focus', onFocus, true, 'parentFocus');
}
